import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Newport Cannabis · Informational Hub</p>
        <h1>Your Source for Cannabis Policy and Culture</h1>
        <p className="lede">
          Stay informed with the latest updates on cannabis laws, policies, and cultural insights in our area. 
          Explore educational resources and news coverage that empower you to understand the evolving landscape of cannabis.
        </p>
        <div className="cta-row">
          <a href="/latest-news" target="_self">
            Read the Latest News
          </a>
          <a href="/educational-resources" target="_self" className="secondary">
            Explore Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Law Updates</h2>
          <p>
            Keep up with the latest changes in cannabis legislation and regulations affecting our community.
          </p>
        </article>
        <article>
          <h2>Understanding Legal Status</h2>
          <p>
            Get clear and concise information about the legal status of cannabis in our area, including usage and possession guidelines.
          </p>
        </article>
        <article>
          <h2>Cultural Insights</h2>
          <p>
            Discover articles and features that delve into the cultural aspects of cannabis, from history to current trends.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;